import makeStyles from '@material-ui/core/styles/makeStyles';
import {
  NAVY_BLUE, WARM_GRAY, WHITE, WHITE_ELEMENTARY,
} from '../../../utils/colors/colors.contants';

export default makeStyles({
  primary: {
    width: '305px',
    height: '32px',
    flexGrow: '0',
    margin: '42.5px 108px 0 88px',
    padding: '6px 64px 7px',
    borderRadius: '4px',
    backgroundColor: '#4A4E69',
    color: WHITE,
    '&:hover': {
      backgroundColor: '#5a5e79',
    },
    '&:disabled': {
      backgroundColor: WHITE_ELEMENTARY,
      color: WARM_GRAY,
    },
  },
  secondary: {
    width: '19.5rem',
    height: '3.625rem',
    color: NAVY_BLUE,
    borderRadius: '29px',
    borderColor: NAVY_BLUE,
    fontSize: '1rem',
    backgroundColor: WHITE,
    '&:disabled': {
      backgroundColor: WHITE_ELEMENTARY,
      color: WARM_GRAY,
    },
    '&:hover': {
      backgroundColor: WHITE,
    },
    '@media screen and (max-width: 600px)': {
      width: '100%',
      height: '2.625rem',
    },
  },
  dialog: {
    width: '120px',
    height: '20px',
    fontSize: '15px',
    color: '#006fc2',
    '@media screen and (max-width: 600px)': {
      width: '100%',
      height: '2.625rem',
    },
  },
  dialog_save: {
    width: '269px',
    height: '57px',
    color: '#4A4E69',
    borderRadius: '29px',
    fontSize: '20px',
    borderColor: '#4A4E69',
    border: 'solid 1px #4A4E69',
  },
  div__arrowBtn: {
    width: 'fit-content',
    maxHeight: '34px',
    cursor: 'pointer',
    '& i': {
      fontSize: '32px',
      '@media screen and (max-width: 600px)': {
        fontSize: '24px',
      },
    },
    '& span': {
      fontSize: '16px',
      '&.MuiTouchRipple-root': {
        display: 'none',
      },
    },

  },
  arrow: {
    '&.MuiButton-root': {
      transition: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '&.MuiButton-outlined': {
      border: 'none',
      padding: '0 0 13px 0',
      '@media screen and (max-width: 600px)': {
        padding: '0 0 6px 0',
      },
    },
    '&.MuiButton-labe': {
      fontSize: '16px',
    },
  },
  div__icon: {
    display: 'flex',
    position: 'relative',
    right: '20px',
  },
});
